import {
  SharedserviceMelcoModelsAlphabetListItem,
  EfsMelcoModelsUserAlphabet,
  selectThumbnailForSize,
} from "melco-shared-logic";

export const useFontThumbnailURL = (
  font: EfsMelcoModelsUserAlphabet | SharedserviceMelcoModelsAlphabetListItem,
  width: number,
  height: number
) => {
  const thumbnail = selectThumbnailForSize(
    font.previews ?? [],
    Math.max(width, height)
  );

  return thumbnail?.url;
};
